import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [installPrompt, setInstallPrompt] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, [location]);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      setInstallPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    installPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      }
      setInstallPrompt(null);
    });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    setIsLoggedIn(false);
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={`${process.env.PUBLIC_URL}/logo-circle.png`} alt="i2r" className="navbar-logo-img" />
        </Link>
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-links" onClick={toggleMenu}>
              홈
            </Link>
          </li>
          <li className="nav-item">
            {isLoggedIn ? (
              <Link to="/overview" className="nav-links" onClick={toggleMenu}>
                대시보드
              </Link>
            ) : (
              <a href="/#dashboard-preview" className="nav-links" onClick={toggleMenu}>
                대시보드
              </a>
            )}
          </li>
          <li className="nav-item">
            <a href="https://github.com/kdi6033" target="_blank" rel="noreferrer" className="nav-links" onClick={toggleMenu}>
              문서
            </a>
          </li>
          <li className="nav-item">
            <Link to="/products" className="nav-links" onClick={toggleMenu}>
              제품
            </Link>
          </li>
          <li className="nav-item">
            <a href="https://www.youtube.com/@i2r-link" target="_blank" rel="noreferrer" className="nav-links" onClick={toggleMenu}>
              유튜브
            </a>
          </li>
          <li className="nav-item">
            <Link to="/firmware" className="nav-links" onClick={toggleMenu}>
              펌웨어
            </Link>
          </li>
          {installPrompt && (
            <li className="nav-item">
              <span className="nav-links" onClick={() => { handleInstallClick(); toggleMenu(); }} style={{ cursor: 'pointer' }}>
                앱 설치
              </span>
            </li>
          )}
          <li className="nav-item">
            <Link
              to="/ble"
              className="nav-links-mobile"
              onClick={toggleMenu}
            >
              연결
            </Link>
          </li>
          <li className="nav-item">
            {isLoggedIn ? (
              <span className="nav-links-mobile" onClick={() => { handleLogout(); toggleMenu(); }}>
                로그아웃
              </span>
            ) : (
              <Link to="/login" className="nav-links-mobile" onClick={toggleMenu}>
                로그인
              </Link>
            )}
          </li>
        </ul>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {installPrompt && (
            <button onClick={handleInstallClick} className="btn-login" style={{ backgroundColor: '#ff9800', borderColor: '#ff9800' }}>
              앱 설치
            </button>
          )}
          <Link to="/ble" className="btn-login">
            연결
          </Link>
          {isLoggedIn ? (
            <button onClick={handleLogout} className="btn-login">로그아웃</button>
          ) : (
            <Link to="/login" className="btn-login">로그인</Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
